module.exports = "/assets/site/images/custom-competition-header-image_1.jpg?ba03a2f1ba44bf9ba1975e94fad77f2d";